import { api } from "@/services/api"
import { useQuery } from "@tanstack/react-query"

interface GetActivityParams {
  startDate?: string
  endDate?: string
  userWeeklyObjectiveId?: string
}

export default function useGetActivities(values: GetActivityParams = {}) {
  const query = useQuery({
    queryKey: ["planner-get-activities"],
    queryFn: async () => {
      const data = await api.cronos.activities.get(values)
      return data.data.description
    },
    refetchOnWindowFocus: true,
    staleTime: 5 * 60 * 1000, // 5 minutes
  })

  return query
}
